import ErrorBoundary from './components/Shared/ErrorBoundary'
// import Index from './components/Default/Pages/Index'
// import Search from './components/Default/Pages/Search'
// import ItemPage from './components/Default/Pages/Item'
import AdminLoginPage from './components/Admin/Pages/Login'
import history from './history'
import OrdersPage from './components/Admin/Pages/Orders'
import { Component } from 'react/cjs/react.production.min'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
// import CheckoutPage from './components/Default/Pages/Checkout'
import AdminAuth from './components/Admin/Auth'
import OrderPage from './components/Admin/Pages/Order'
import OrderCustomerEditPage from './components/Admin/Pages/Order/Customer/Edit'

import InvoicesPage from './components/Admin/Pages/Invoices'
// import OrderConfirmPage from './components/Default/Pages/OrderConfirm'
// import OrderConfirmLandingPage from './components/Default/Pages/OrderConfirmLanding'
import EmployeeList from './components/Admin/Pages/Sales/EmployeeList'
import EmployeeAddPage from './components/Admin/Pages/Sales/EmployeeAdd'
import EmployeeEditPage from './components/Admin/Pages/Sales/EmployeeEdit'
import InitStoreFromQueryString from './components/Shared/InitStoreFromQueryString'
import CancellationPage from './components/Default/Pages/Cancellation'
import CancellationConfirmPage from './components/Default/Pages/Cancellation/Confirm'
import HotelChainPage from './components/Default/Pages/HotelChain'
import GoogleAnalytics from './components/Shared/GoogleAnalytics/googleAnalytics'
import Hubspot from './components/Shared/HubSpot/hubspot'

class AppRouter extends Component {
  render () {
    const notAuthenticatedAdminRedirectPath = '/admin/login'

    return (
      <Router history={history}>
        <ErrorBoundary>
          <InitStoreFromQueryString/>
          <Switch>
            {/*<Route exact={true} path="/" component={Index}/>*/}
            {/*<Route exact={true} path="/cart" component={CartPage}/>*/}
            {/*<Route exact={true} path="/search" component={Search}/>*/}
            {/*<Route exact={true} path="/item/:id" component={ItemPage}/>*/}
            {/*<Route exact={true} path="/checkout" component={CheckoutPage}/>*/}
            <Route exact={true} path="/cancellation" component={CancellationPage}/>
            <Route exact={true} path="/cancellation/:token" component={CancellationConfirmPage}/>
            {/*<Route exact={true} path="/order/confirm" component={OrderConfirmPage}/>*/}
            {/*<Route exact={true} path="/order/landing" component={OrderConfirmLandingPage}/>*/}
            <Route exact={true} path="/hotel-chain" component={HotelChainPage}/>
            <Route exact={true} path="/admin/login" component={AdminLoginPage}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/orders" component={OrdersPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/orders/:id" component={OrderPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/orders/:id/customer" component={OrderCustomerEditPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/invoices" component={InvoicesPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/sales/employees" component={EmployeeList}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/sales/employees/add" component={EmployeeAddPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <AuthenticatedAdminRoute exact={true} path="/admin/sales/employees/:id" component={EmployeeEditPage}
                                     authenticated={this.props.isAdminAuthenticated}
                                     redirectPath={notAuthenticatedAdminRedirectPath}/>
            <Route path="(/admin|/admin/*)">
              <Redirect to="/admin/orders"/>
            </Route>
            <Route path="*">
              <Redirect to="/hotel-chain"/>
            </Route>
          </Switch>
          <GoogleAnalytics trackingId={'G-75RMHM14GR'}/>
          <Hubspot portalId={'5405124'}/>
        </ErrorBoundary>
      </Router>
    )
  }
}

function AuthenticatedAdminRoute ({ component: Component, authenticated, redirectPath, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authenticated === true
        ? <AdminAuth><Component {...props} /></AdminAuth>
        : <Redirect to={{ pathname: redirectPath, state: { from: props.location } }}/>}
    />
  )
}

const mapStateToProps = state => ({
  isAdminAuthenticated: !!state.adminUser.loggedIn
})
export default connect(mapStateToProps, {})(AppRouter)
